import * as Matter from 'matter-js';

export interface BodyStyle {
  fill: string;
  stroke: string;
  groundFill: string;
}

export function drawBody(ctx: CanvasRenderingContext2D, body: Matter.Body, style: BodyStyle): void {
  const fill = body.isStatic ? style.groundFill : style.fill;
  ctx.beginPath();
  const verts = body.vertices;
  ctx.moveTo(verts[0]!.x, verts[0]!.y);
  for (let i = 1; i < verts.length; i++) ctx.lineTo(verts[i]!.x, verts[i]!.y);
  ctx.closePath();
  ctx.fillStyle = fill;
  ctx.fill();
  ctx.strokeStyle = style.stroke;
  ctx.lineWidth = 1.5;
  ctx.stroke();
}

export function drawConstraint(
  ctx: CanvasRenderingContext2D,
  c: Matter.Constraint,
  style: BodyStyle,
): void {
  const aPos = c.bodyA ? c.bodyA.position : { x: 0, y: 0 };
  const bPos = c.bodyB ? c.bodyB.position : { x: 0, y: 0 };
  const aOffset = c.pointA ?? { x: 0, y: 0 };
  const bOffset = c.pointB ?? { x: 0, y: 0 };
  const ax = aPos.x + aOffset.x;
  const ay = aPos.y + aOffset.y;
  const bx = bPos.x + bOffset.x;
  const by = bPos.y + bOffset.y;
  ctx.strokeStyle = style.stroke;
  ctx.lineWidth = (c.stiffness ?? 1) < 1 ? 2 : 1.5;
  if ((c.stiffness ?? 1) < 1) {
    const dx = bx - ax;
    const dy = by - ay;
    const len = Math.hypot(dx, dy);
    const segs = 8;
    const amp = 5;
    ctx.beginPath();
    ctx.moveTo(ax, ay);
    for (let i = 1; i < segs; i++) {
      const t = i / segs;
      const px = ax + dx * t;
      const py = ay + dy * t;
      const perpX = (-dy / len) * amp * (i % 2 === 0 ? 1 : -1);
      const perpY = (dx / len) * amp * (i % 2 === 0 ? 1 : -1);
      ctx.lineTo(px + perpX, py + perpY);
    }
    ctx.lineTo(bx, by);
    ctx.stroke();
  } else {
    ctx.beginPath();
    ctx.moveTo(ax, ay);
    ctx.lineTo(bx, by);
    ctx.stroke();
  }
}
